import styled from 'styled-components';
import { Screen, screenBiggerThan } from '@client/styles/styled-components/breakpoints';

export const TabsContainer = styled.div`
    padding: 0;
    display: flex;
    width: 100%;
    overflow-x: auto;
    scroll-behavior: smooth;
    box-sizing: content-box;
    flex: 1 0 auto;
    scrollbar-width: none; //NOSONAR
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
        width: 0;
        height: 0;
    }
`;

export const Tabs = styled.div`
    display: flex;
    height: 50px;
    align-items: center;

    ${screenBiggerThan(Screen.tablet)} {
        padding: 0 3%;
    }
`;
